import logo from "./logo.svg";
import Login from "./pages/Login";
import Counter from "./pages/Counter";
import Dashboard from "./pages/Dashboard";
import VolatilityAnalysis from "./pages/VolatilityAnalysis";
import COTAnalysis from "./pages/COTAnalysis";
import Correlation from "./pages/Correlation";
import Register from "./pages/Register";
import ManageAccount from "./pages/ManageAccount";
import PasswordReset from "./pages/PasswordResetRequest";
import PasswordResetFinalize from "./pages/PasswordResetFinalize";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoutes from "./components/auth/PrivateRoutes";
import ProtectedRoutes from "./components/auth/ProtectedRoutes";
import { useEffect } from "react";
import { useAppDispatch } from "./hooks/redux";
import { checkLogin } from "./components/auth/authActions";
import "./App.css";
import "./GlobalStyles.scss";
import useCheckPermsOnLocationChange from "./hooks/useCheckPermsOnLocationChange";
import RollAgenda from "./pages/RollAgenda";
import IRRAnalysis from "./pages/IRRAnalysis";
import COTPortfolio from "./pages/COTPortfolio";


function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    console.log("App dispatch called");
    const checkAuth = async () => {
      try {
        await dispatch(checkLogin()).unwrap();
      } catch (error) {
        // Silently handle error - user is not logged in
        console.debug("No active session found");
      }
    };
    checkAuth();
  }, [dispatch]);

  const ScopeWrapper = ({ children }: { children: React.ReactNode }) => {
    useCheckPermsOnLocationChange();
    return children;
  };

  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <ScopeWrapper>
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <Navigate to="/login" />
              </div>
            }
          />
          <Route
            path="/login"
            element={
              <Login
                resetPasswordUrl="/reset-password"
                registerUrl="/register"
                // exitUrl="/loading-screen"
                exitUrl="/dashboard"
              />
            }
          />
          <Route
            path="/register"
            element={<Register loginUrl="/login" exitUrl="/dashboard" />}
          />

          <Route
            path="/reset-password"
            element={
              <PasswordReset loginUrl="/login" exitUrl="/loading-screen" />
            }
          />
          <Route
            path="/reset-password-finalize"
            element={
              <PasswordResetFinalize loginUrl="/login" exitUrl="/dashboard" />
            }
          />

          <Route path="/counter" element={<Counter />} />
          {/*<Route path="/volatility-analysis" element={<VolatilityAnalysis />} />*/}
          <Route element={<PrivateRoutes />}>
            <Route path="/manage-account" element={<ManageAccount />} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/volatility-analysis" element={<VolatilityAnalysis />} />
              <Route path="/COT-analysis/:root?" element={<COTAnalysis />} />
              <Route path="/COT-portfolio" element={<COTPortfolio />} />
              <Route path="/correlation" element={<Correlation />} />
              <Route path="/irr-analysis" element={<IRRAnalysis />} />
              <Route path="/roll-agenda" element={<RollAgenda />} />

            </Route>
          </Route>
        </Routes>
      </ScopeWrapper>
    </BrowserRouter>
  );
}

export default App;
